export const BuildInfo = {timestamp:1777075631000}
